import { AnimatePresence, motion } from 'framer-motion';
import { useContext, useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { addIndexHtmlLinks } from '../../links/AppLinks';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { RoutesContext } from '../cnr/contexts/RoutesContext';
import PageError, { pageErrorReasonTypes } from '../components/alerts/PageError';
import { _animateTypes } from '../motions/AnimateComponent';
import ModalPage from './ModalPage';

// const pageTransitionVariants = {
//   initial: (direction) => ({
//     x: direction > 0 ? 300 : -300, // Slide in from right if direction > 0, from left otherwise
//     opacity: 0,
//   }),
//   animate: {
//     x: 0, // Center the component
//     opacity: 1,
//     transition: { duration: 0.5 },
//   },
//   exit: (direction) => ({
//     x: direction > 0 ? -300 : 300, // Slide out to the left if direction > 0, to the right otherwise
//     opacity: 0,
//     transition: { duration: 0.5 },
//   }),
// };

/**
 * 
 * @param {object} props 
 * @returns a Route for the page
 */
const AppPage = (props) => {

  const navigate = useNavigate()

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { appSettings_state, paps_state, manifest_state, currentSettings_state, transition_state } = states
  const { transition_handlers, start_handlers } = handlers
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { manifest } = aps_global ?? {}
  const { name: name_manifest } = manifest ?? {}
  const { transitions } = transition_state ?? {}
  const transition = transitions ? transitions[_animateTypes.route] : null
  const { showTransition } = transition ?? {}
  const { manifestIcons } = manifest_state ?? {}
  const { demoOverrideOn } = appSettings_state ?? {}

  const { rootPaths } = paps_state
  const { aps_views } = _.get(currentSettings_state, 'gvviSettings', {});

  // routesContext
  const routesContext = useContext(RoutesContext)
  const { routes_state } = routesContext ?? {}
  const { viewRoutes, genericRoutes } = routes_state ?? {}

  // pageContext 
  const { projectOptions } = aps_global ?? {}
  const { useEventViewRoutes } = projectOptions ?? {}

  // getting the routes!!!
  const _routes = useEventViewRoutes && 1 === 3 ? viewRoutes : genericRoutes

  const indexRef = useRef(0);

  useEffect(() => {
    start_handlers.handleAmmend_useEffect('addIndexHtmlLinks')
    addIndexHtmlLinks(aps_global, manifest_state)
    // if (useCssFile && cssFile) { addCssFile(cssFile) }
    // addCssFile('CssTest.css')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manifestIcons, name_manifest]);

  useEffect(() => {
    if (navigate && demoOverrideOn) {
      const _aps_views = _.pickBy(aps_views, (val, key) => val.show && !key.includes('_'));
      const _aps_view_keys = _.keys(_aps_views);
      _aps_view_keys.push('landing')
      const interval = setInterval(() => {
        indexRef.current = (indexRef.current + 1) % _aps_view_keys.length;
        const _path = rootPaths.events + _aps_view_keys[indexRef.current]
        navigate(_path);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [demoOverrideOn]);

  return _routes ?
    <PageSwitch
      {...props}
      routes={_routes}
      useRouteTransitions={showTransition}
      transition_handlers={transition_handlers}
    />
    :
    <div></div>
}

/**
 * 
 * @param {object} props 
 * @returns a Route for the page
 */
const PageSwitch = (props) => {

  const pageVariants = {
    initial: { opacity: 1 }, // Start with the new page invisible
    animate: {
      opacity: 1, // Fade in the new page
      transition: {
        duration: 0.2, // Adjust duration for smooth fade-in
        ease: "easeOut"
      }
    },
    exit: {
      opacity: .9, // Fade out the old page
      transition: {
        duration: 0.2, // Match the duration to the "animate" transition for a smoother experience
        ease: "easeIn"
      }
    },
  };

  const { routes, useRouteTransitions } = props ?? {}

  const location = useLocation()
  const [trueLocation, setTrueLocation] = useState(location)
  const [previousLocation, setPreviousLocation] = useState(null);

  const _newRoute = previousLocation ? trueLocation.pathname === previousLocation.pathname : false

  const modalMode = trueLocation?.state?.modalMode

  useEffect(() => {
    setTrueLocation(location)
    // console.group('location')
    // console.log('Current route:', location);
    // console.log('Pathname:', location.pathname);
    // console.log('Hash:', location.hash);
    // console.log('Search:', location.search);
    // console.groupEnd()
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [location]);

  useEffect(() => {
    setPreviousLocation(location)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [location]);

  useEffect(() => {
    // transition_handlers.handleIsNewRoute(_newRoute)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [_newRoute]);

  if (trueLocation) {

    if (useRouteTransitions) {
      return (
        // <RouteContext.Provider value={{ route_state: { newRoute: _newRoute } }}>
        <AnimatePresence mode="wait" custom={previousLocation} >
          <Routes location={trueLocation} key={trueLocation.key}> {/* Use hash for key */}
            {routes.map((route) => (
              <Route
                key={route.props.key} // Use route.props.key
                path={route.props.path} // Use route.props.path
                element={
                  <motion.div
                    variants={pageVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                  >
                    {route.props.element} {/* Use route.props.element */}
                  </motion.div>
                }
              />
            ))}
            <Route
              path="*"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                >
                  <PageError reason={pageErrorReasonTypes.noPage} />
                </motion.div>
              }
            />
          </Routes>
        </AnimatePresence>
        // </RouteContext.Provider>
      )
    } else {
      return (
        <>
          {/* Main content */}
          <Routes location={trueLocation} key={trueLocation.key}>
            {routes}
            <Route path="*" element={<PageError reason="noPage" />} />
          </Routes>

          {/* Modal overlay (only if modalMode is set) */}
          {modalMode && (
            <Routes>
              <Route path={trueLocation.pathname} element={<ModalPage />} />
            </Routes>
          )}
        </>
        // <Routes location={trueLocation} key={trueLocation.key}>
        //   {routes}
        //   <Route path="*" element={<PageError reason={pageErrorReasonTypes.noPage} />}></Route>
        // </Routes>
      )
    }
  }

  return <div></div>

}

export default AppPage